import axios from "axios";
import { baseUrl } from "api/baseUrl";
import { toApiUrl, toApiUrls } from "api/client";

// 멀티파트 업로드는 apiClient(JSON 기본 헤더)가 아닌 별도 axios 호출로 처리한다.
// Content-Type 은 브라우저가 boundary 포함하여 자동 설정하도록 비워둔다.

// category: 'community' | 'match' | 기타 폴더명
export async function uploadImagesApi(category, docId, files) {
  if (!files || files.length === 0) return [];
  const form = new FormData();
  for (const f of files) {
    if (f instanceof File || f instanceof Blob) {
      form.append("images", f);
    }
  }
  const { data } = await axios.post(
    `${baseUrl}/post/upload/${encodeURIComponent(category)}/${encodeURIComponent(docId)}`,
    form,
    { timeout: 60000 },
  );
  if (data && data.success && Array.isArray(data.urls)) return toApiUrls(data.urls);
  return [];
}

export async function uploadVoiceApi(docId, file) {
  if (!file) return null;
  const form = new FormData();
  form.append("voice", file);
  const { data } = await axios.post(
    `${baseUrl}/post/upload/voice/${encodeURIComponent(docId)}`,
    form,
    { timeout: 120000 },
  );
  if (data && data.success) return toApiUrl(data.url) || null;
  return null;
}

export async function deleteUploadsApi(urls) {
  if (!urls || urls.length === 0) return { success: true };
  const { data } = await axios.post(
    `${baseUrl}/post/upload/delete`,
    { urls },
    { timeout: 15000 },
  );
  return data;
}
